// extracted by mini-css-extract-plugin
module.exports = {"Form":"Auth_Form__1Tklh"};